import React from 'react';
import GenericList from './GenericList';
import GenericDetail from './GenericDetail';
import GenericCompare from './GenericCompare';

/**
 * Bind the generic pair to one URL segment.
 *
 * `EntityRoute` renders `<List />` and `<Detail />` with no props (it selects
 * between them purely on `?slug=`, and 05 §4 keeps it untouched), so a Family's
 * segment is bound here instead of passed through it.
 *
 * All ten UI Families run on this pair (P4 R6-R12). Since the R13 collapse
 * there is no per-Family route line left: `App.js`'s catch-all
 * `<Route path="/:familyPath">` resolves the segment against the Family
 * registry and renders the pair this returns — a segment is a content page
 * exactly when a navigable canonical family claims it (05 §1.1, §6.2).
 */
export default function genericFamily(segment) {
  return {
    List: () => <GenericList segment={segment} />,
    Detail: () => <GenericDetail segment={segment} />,
    Compare: () => <GenericCompare segment={segment} />,
  };
}

export { GenericList, GenericDetail, GenericCompare };
